import type { IconSvgObject } from './types';

const Archive04Icon: IconSvgObject = [
  ["path", { d: "M16.6459 3H7.35407C6.53626 3 5.80084 3.4979 5.49711 4.25722L2.14305 12.6424C2.04855 12.8786 2 13.1307 2 13.3852V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V13.3852C22 13.1307 21.9514 12.8786 21.857 12.6424L18.5029 4.25722C18.1992 3.4979 17.4637 3 16.6459 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 13H7L9 15H15L17 13H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Archive04Icon;
